import cx from 'classnames';
import { ELSIconV2 } from 'components/common';
import Pill from 'components/common/pill/Pill';
import { PS_PILL_TITLES } from 'reports/ps/constants';
import LinkButton from '../link-button/LinkButton';
var NavigationCard = function (_a) {
    var item = _a.item, titleKey = _a.titleKey, description = _a.description, pills = _a.pills, onNavigate = _a.onNavigate;
    if (item.disabled)
        return null;
    return (<LinkButton onClick={function () { return onNavigate(item); }} type="container">
      <div className={cx('c-ps-nav-menu-card', { 'c-ps-nav-menu-card--selected': item.isSelected })}>
        <div className="c-ps-nav-menu-card__title c-ps-nav-menu-card__title--top">
          <span className={cx({ 'c-ps-nav-menu-card__title--selected': item.isSelected })}>{PS_PILL_TITLES[titleKey]}</span>
        </div>
        <span className="u-els-margin-bottom-1x u-els-font-size-body">{description}</span>
        <div className="c-ps-nav-menu__pill-row-container">
          <div className="c-ps-nav-menu__pill c-ps-nav-menu__pill--row-item">Connected insights from:</div>
          {pills.map(function (_a, idx) {
            var color = _a.color, icon = _a.icon, text = _a.text, iconClass = _a.iconClass;
            return (
            // eslint-disable-next-line react/no-array-index-key
            <Pill key={"".concat(idx, "-").concat(text)} className={cx('c-ps-nav-menu__pill', "c-ps-nav-menu__pill--".concat(color), { 'c-ps-nav-menu__pill--row-item': idx < pills.length - 1 })}>
              <ELSIconV2 id={icon} sprite={icon} size="xs" className={cx('c-ps-nav-menu__pill-icon', iconClass)}/>
              <span className="c-ps-nav-menu__pill-text">{text}</span>
            </Pill>);
        })}
        </div>
      </div>
    </LinkButton>);
};
export default NavigationCard;
